const hasDomAccess =
  typeof window !== "undefined" && typeof document !== "undefined";

const initLibraryCalendar = () => {
  if (!hasDomAccess) return;

  const containers = document.querySelectorAll(".js-library-calendar");
  if (!containers.length) {
    return;
  }

  containers.forEach((container) => {
    const months = Array.from(
      container.querySelectorAll("[data-library-month]")
    );
    if (!months.length) {
      return;
    }

    const prevButton = container.querySelector("[data-library-nav='prev']");
    const nextButton = container.querySelector("[data-library-nav='next']");
    const labelEl = container.querySelector("[data-library-month-label]");
    let activeIndex = months.findIndex((month) =>
      month.classList.contains("is-active")
    );

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    const update = () => {
      months.forEach((month, index) => {
        const isActive = index === activeIndex;
        month.classList.toggle("is-active", isActive);
        month.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      if (prevButton) {
        prevButton.disabled = activeIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = activeIndex === months.length - 1;
      }
      if (labelEl) {
        const label = months[activeIndex]?.dataset.libraryMonthLabel || "";
        labelEl.textContent = label;
      }
    };

    prevButton?.addEventListener("click", (event) => {
      event.preventDefault();
      if (activeIndex === 0) {
        return;
      }
      activeIndex -= 1;
      update();
    });

    nextButton?.addEventListener("click", (event) => {
      event.preventDefault();
      if (activeIndex >= months.length - 1) {
        return;
      }
      activeIndex += 1;
      update();
    });

    update();
  });
};

export { initLibraryCalendar as default };
